import { useState } from 'react'
import dynamic from 'next/dynamic'


import { useStore } from '@/lib/store';
import { ElementProps, PageBlock } from '@/types/elements';

const parseString = (str: string) => {
  const regex = /\\n|\\r\\n|\\n\\r|\\r/g;
  return str.replace(regex, '<br>')
}

export default function TextElement({ block }: ElementProps) {

  return (
    <div className="relative">
      <p className="text-sm md:text-md text-body !font-Inter" 
      dangerouslySetInnerHTML={{ '__html': block.data['html'] ?? parseString(block.data['text']) }}>

      </p>
    </div>
  )
}

